<ng-container *ngIf="hasLumpSum">
  <div class="responsive-card gap-4">
    <div i18n class="responsive-card-title">Lump Sum Payments</div>
    <div class="inner-card d-flex flex-column gap-4">
      <div class="payment-date" i18n>Payment on {{ paymentDate | date : 'MMMM d, yyyy' }}</div>
      <div class="d-flex flex-column gap-3">
        <ng-container *ngFor="let row of rows; let last = last">
          <div class="payment-row">
            <div class="paragraph-lg">{{ row.jurisdictionName }}</div>
            <div class="row-amount">{{ row.amount | currency }}</div>
          </div>
          <hr *ngIf="!last" class="m-0" />
        </ng-container>
        <hr class="m-0" />
      </div>
      <div class="payment-row">
        <span i18n class="title-sm">Lump Sum Payments Total:</span>
        <span class="total-amount">{{ total | currency }}</span>
      </div>
    </div>
  </div>
</ng-container>
